<template>
    <div class="row mb-3" v-if="isOwner">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-12">
                    <div class="input-group vcall-group">
                        <label class="vcall-link pr-3">
                            <span><vue-feather type="video" size="18"></vue-feather></span>
                            {{ $t(`CRMSetting.CalenderVideoCallLinkToJoin`) }}:
                        </label>
                        <input type="text" class="form-control" placeholder="Search" ref="roomlink" name="search"
                            :value="baseUri + '/videoChat?joinId=' + RoomJoiningLink" readonly>
                        <div class="input-group-btn">
                            <button class="btn bg-success border-0 text-white" type="button" @click="CopyLink(roomlink)"
                                style="padding: 5px 10px; border-radius: 0px 5px 5px 0px !important;">
                                <vue-feather type="copy" style="font-size: x-large;" :title="$t(`CRMSetting.CalenderVideoCallCopyLinkToJoin`)"
                                    :tooltip="$t(`CRMSetting.CalenderVideoCallCopyLinkToJoin`)"></vue-feather>                          
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, onMounted, watch, computed, getCurrentInstance } from "vue";
import VideoChatService from "@/service/crmservice/videochat.service";
import {  useRoute } from "vue-router";
import { createToaster } from "@meforma/vue-toaster";
import { useI18n } from 'vue-i18n';


export default {
    name: 'rooms',
    components: {

    },
    props: {
        activeRoomName: String,
        defaultRoom: String,
        createRoom: String,
        isOwner: Boolean,
    },
    setup(props, ctx) {
        const { t } = useI18n();
        const activeProps = computed(() => props.activeRoomName)
        console.log("activeProps",activeProps)
        const toaster = createToaster({ position: "top-right" });
        const thisApp = getCurrentInstance();
        const filters = thisApp.appContext.config.globalProperties.$filters;
        const videoChatService = ref(new VideoChatService());
        const roomName = ref(null);
        const rooms = ref([])
        const route = useRoute();
        const join = ref(false);
        const joinId = ref(null);
        const companyId = ref(null);
        const userId = ref(null)
        const baseUri = window.location.origin;
        const subscription = ref(null)
        const userInfo = ref(null);
        const roomChanged = ref(null);
        const participantCount = ref(null);
        const roomlink = ref(null);
        const RoomJoiningLink = ref("")

        const onTryAddRoom = () => {
            if (roomName.value) {
                onAddRoom(roomName.value);
            }
        }

        const onAddRoom = (roomName) => {
            ctx.emit("roomChanged", roomName);
        }


        watch(activeProps, async (newValue, oldValue) => {
            if (newValue) {
                console.log("newValue", newValue);
                await updateRooms();
                filterRoomJoiningLink();
            }

        })

      

        const onJoinRoom = (roomName) => {
            props.roomChanged.emit("roomChanged", roomName);
        }

        const updateRooms = async () => {
            rooms.value = (await videoChatService.value.getAllRooms(companyId.value, null));
            console.log("rooms.value", rooms.value);
        }

        const getRooms = async (joinId, companyId) => {
            rooms.value = await videoChatService.value.joinRooms(joinId, companyId);
            return rooms.value;

        }


        const filterRooms = () => {
            if (rooms.value != undefined && rooms.value.data.length > 0) {
                if (rooms.value.data.find(x => x.name == props.activeRoomName)) {
                    ctx.emit('participantCount',rooms.value.data.find(x => x.name == props.activeRoomName).participantCount)
                }
                return rooms.value.data.filter(x => x.name == props.activeRoomName);

            } else {
                return [];
            }

        }
        const filterRoomJoiningLink = () => {
            RoomJoiningLink.value = null;
            if (rooms.value.data != undefined && rooms.value.data.length > 0) {
                if (activeProps.value) {            
                    if (rooms.value.data.find(x => x.name == activeProps.value)) {            
                        RoomJoiningLink.value = rooms.value.data.find(x => x.name == activeProps.value).id + "&companyId=" + companyId.value.toLowerCase();
                        return rooms.value.data.find(x => x.name == activeProps.value).id + "&companyId=" + companyId.value;
                    } else {
                        return "";
                    }
                }

            } else {
                return "";
            }

        }
        const filterRoomJoiningId = () => {
            if (rooms.value != undefined && rooms.value.data.length > 0) {
                if (rooms.value.data.find(x => x.name == props.activeRoomName)) {
                    return rooms.value.data.find(x => x.name == props.activeRoomName).id;
                } else {
                    return "";
                }
            } else {
                return "";
            }

        }
        const CopyLink = (e) => {
            if (e) {
                const selBox = document.createElement('textarea');
                selBox.style.position = 'fixed';
                selBox.style.left = '0';
                selBox.style.top = '0';
                selBox.style.opacity = '0';
                selBox.value = e.value;
                document.body.appendChild(selBox);
                selBox.focus();
                selBox.select();
                document.execCommand('copy');
                document.body.removeChild(selBox);
                //toaster.success("Link Copied")
                toaster.success(t('CRMSetting.CalenderVideoCallLinkCopied'));
            }

        }

        //====================== onMounted ===========================

        // onBeforeMount(async () => {
        //     getUserInfo();
        // })

        onMounted(async () => {
            joinId.value = route.query.joinId;
            companyId.value = route.query.companyId;

            if (joinId.value) {
                join.value = true;
            }

            if (localStorage.getItem('userinfo')) {
                userInfo.value = JSON.parse(localStorage.getItem('userinfo'));
                companyId.value = userInfo.value.data.companyId;
            }

            if (join.value) {
                await getRooms(joinId.value, companyId.value);

            }
            else {
                console.log("updateRooms")
                // console.log("videoStore.room",videoStore.room)
                // rooms.value = videoStore.room;
                // console.log(" rooms.value", rooms.value)
                await updateRooms();
                if (rooms.value.data.length > 0) {

                     //filterRoomJoiningLink()
                }
                console.log("rooms.value", rooms.value);
                if (rooms.value.data.length == 0 || rooms.value.data.filter(x => x.name == props.defaultRoom || x.name == roomName.value).length == 0) {
                    onAddRoom(props.defaultRoom);
                }
            }

        });

        //====================== return ===========================

        return {
            participantCount,
            roomChanged,
            roomName,
            rooms,
            join,
            activeProps,
            joinId,
            companyId,
            baseUri,
            subscription,
            userInfo,
            roomlink,
            filters,
            toaster,
            userId,
            RoomJoiningLink,
            onTryAddRoom,
            onAddRoom,
            onJoinRoom,
            updateRooms,
            getRooms,
            filterRooms,
            filterRoomJoiningId,
            CopyLink
        }
    },
}
</script>

<style scoped>
div.jumbotron {
    background-color: transparent;
}

button>i {
    padding-right: 6px;
}

.twitter-red {
    color: #F22F46;
}

a {
    font-size: 1.25rem;
}

.vcall-link {
    font-size: 18px;
    padding-top: 5px;
}

.vcall-link span {
    background: #2e80fb;
    padding: 9px;
    border-radius: 6px;
    color: #fff;
}

.vcall-group .form-control {
    border-radius: .2rem 0 0 .2rem !important;
}
</style>
